var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatSend(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8151 12.197L5.28308 13.453C5.19649 13.4675 5.11522 13.5045 5.04746 13.5603C4.97971 13.6161 4.92784 13.6888 4.89708 13.771L2.30008 20.728C2.05208 21.368 2.72108 21.978 3.33508 21.671L21.3351 12.671C21.4598 12.6088 21.5646 12.513 21.6379 12.3945C21.7112 12.276 21.75 12.1394 21.75 12C21.75 11.8607 21.7112 11.7241 21.6379 11.6056C21.5646 11.487 21.4598 11.3913 21.3351 11.329L3.33508 2.32902C2.72108 2.02202 2.05208 2.63302 2.30008 3.27202L4.89808 10.229C4.92869 10.3114 4.9805 10.3843 5.04827 10.4403C5.11604 10.4963 5.19737 10.5335 5.28408 10.548L12.8161 11.803C12.8624 11.8111 12.9044 11.8353 12.9347 11.8714C12.965 11.9074 12.9816 11.953 12.9816 12C12.9816 12.0471 12.965 12.0926 12.9347 12.1287C12.9044 12.1647 12.8624 12.1889 12.8161 12.197H12.8151Z",
    fill: "#6467EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/chat-send.89c8e53e.svg";
export { ForwardRef as ReactComponent };